import { StyleSheet, Platform } from 'react-native';
import { BREAKPOINTS, getResponsiveValue } from './breakpoints';
import './fonts.css';
import {spacing, colors, animations} from "./theme.js"

export const globalStyles = StyleSheet.create({
  headerLeftContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    width: 'auto',
  },
  container: {
    flex: 1,
    backgroundColor: '#E9E9E9',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    width: '100%',
    fontFamily: 'VastagoGrotesk, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    ...(Platform.OS === 'web' && {}),
  },
  backgroundImage: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -1,
  },
  overlay: {
    flex: 1,
    backgroundColor: '#E9E9E9',
    width: '100%',
    minHeight: "100vh",
    height: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: getResponsiveValue({
      mobile: spacing.xl,
      tablet: spacing.xxl,
      laptop: spacing.header,
      desktop: spacing.header
    }),
    paddingBottom: spacing.xl,
    backdropFilter: 'blur(15px)',
    position: 'relative',
    zIndex: 1,
    overflowX: 'hidden',
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '100%',
    paddingVertical: Platform.select({
      web: 40,
      default: 20
    }),
  },
  logo: {
    width: Platform.OS === 'web' ? 200 : 150,
    height: Platform.OS === 'web' ? 200 : 150,
    marginBottom: 20,
  },
  headerLogo: {
    width: 80,
    height: 80,
    marginRight: 15,
  },
  title: {
    fontFamily: 'Playpen Sans',
    fontSize: Platform.OS === 'web' ? 72 : 48,
    textShadow: '0px 2px 4px rgba(0,0,0,0.25)',
    color: 'black',
    marginBottom: 20,
    textAlign: 'center',
  },
  comingSoon: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: Platform.OS === 'web' ? 48 : 32,
    color: '#ffffff',
    marginBottom: 40,
    textAlign: 'center',
  },
  errorText: {
    color: '#ff6b6b',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: Platform.OS === 'web' ? 16 : 12,
    marginTop: 10,
    textAlign: 'center',
  },
  profileCard: {
    width: '100%',
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
    backdropFilter: 'blur(20px)',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    minHeight: 300,
  },
  profileCard1: {
    width: '100%',
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
    backdropFilter: 'blur(20px)',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    minHeight: 300,
  },
  profileDetailsCard: {
    width: '100%',
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 20,
    backdropFilter: 'blur(20px)',
    ...(Platform.OS === 'web' ? { boxShadow: '0 4px 8px rgba(0,0,0,0.25)' } : {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.25,
      shadowRadius: 4,
    }),
    minHeight: 400,
  },
  profileImageContainer: {
    position: 'relative',
    marginBottom: 15,
  },
  profileImage: {
    width: 150,
    height: 150,
    borderRadius: 75,
    marginBottom: 10,
  },
  onlineStatus: {
    position: 'absolute',
    right: 10,
    top: 10,
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: '#2ecc71',
    borderWidth: 2,
    borderColor: 'white',
  },
  profileName: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    fontSize: Platform.OS === 'web' ? 32 : 24,
    color: 'white',
    textAlign: 'center',
    marginBottom: 5,
    textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
  },
  profileOccupation: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: Platform.OS === 'web' ? 18 : 14,
    color: '#ff878c',
    textAlign: 'center',
    marginBottom: 10,
    textShadow: Platform.OS === 'web' ? '0px 1px 1px rgba(0,0,0,0.25)' : undefined,
  },
  profileStats: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginTop: 10,
  },
  profileStatText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: Platform.OS === 'web' ? 14 : 12,
    color: 'white',
    textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
  },
  inputGroup: {
    width: '100%',
    marginBottom: 15,
  },
  inputLabel: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: Platform.OS === 'web' ? 16 : 14,
    color: 'white',
    marginBottom: 5,
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  profileInput: {
    backgroundColor: colors.backgroundSquares,
    borderRadius: 100,
    padding: Platform.OS === 'web' ? 12 : 10,
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: Platform.OS === 'web' ? 16 : 14,
    width: '100%',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
    }),
  },
  profileInputText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: Platform.OS === 'web' ? 16 : 14,
  },
  // Header Styles
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 75,
    width: '100%',
    paddingHorizontal: getResponsiveValue({
      mobile: 20,
      tablet: 30,
      laptop: 50,
      desktop: 50
    }),
    paddingVertical: getResponsiveValue({
      mobile: 30,
      tablet: 40,
      laptop: 50,
      desktop: 50
    }),
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    // boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  headerTitle: {
    color: '#3ba378',
    fontFamily: 'Playpen Sans',
    fontWeight: '800',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 18,
      laptop: 20,
      desktop: 24
    }),
    textAlign: 'left',
    marginBottom: 2,
  },
  headerWelcome: {
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 16,
      laptop: 18,
      desktop: 20
    }),
    textAlign: 'left',
  },
  // Header right section container
  headerRightSection: {
    flexDirection: 'row',
    alignItems: 'center',
    ...(Platform.OS === 'web' ? { gap: 15 } : { marginRight: 15 }),
  },

  // Activity Log Bell
  activityBell: {
    position: 'relative',
    padding: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
      },
    }),
  },

  activityBadge: {
    position: 'absolute',
    top: -2,
    right: -2,
    backgroundColor: '#e74c3c',
    borderRadius: 10,
    minWidth: 18,
    height: 18,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
  },

  activityBadgeText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: 10,
    fontWeight: 'bold',
  },

  // Activity Log Panel (no overlay)
  
  activitySidePanel: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: getResponsiveValue({
      mobile: '100vw',
      tablet: '33.33vw',
      laptop: '33.33vw',
      desktop: '33.33vw'
    }),
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    borderLeftWidth: 1,
    borderLeftColor: 'rgba(255, 255, 255, 0.2)',
    zIndex: 10001, // Higher than overlay
    display: 'flex',
    flexDirection: 'column',
  },

  activityPanelHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255, 255, 255, 0.1)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },

  activityPanelTitle: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 18,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    fontWeight: 'bold',
  },

  // Activity Search
  activitySearchContainer: {
    padding: 15,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255, 255, 255, 0.1)',
  },

  activitySearchInput: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 8,
    padding: 12,
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
    }),
  },

  // Activity Stats
  activityStatsContainer: {
    paddingHorizontal: 15,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255, 255, 255, 0.05)',
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
  },

  activityStatsText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontFamily: 'VastagoGrotesk',
    fontSize: 11,
    textAlign: 'center',
  },

  closePanelButton: {
    backgroundColor: '#e74c3c',
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRadius: 6,
    width: 30,
    height: 30,
    alignItems: 'center',
    justifyContent: 'center',
  },

  closePanelText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
    fontWeight: 'bold',
  },

  activityPanelList: {
    flex: 1,
    padding: 10,
  },

  activityItem: {
    padding: 16,
    marginBottom: 10,
    borderRadius: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
  },

  activityVenue: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 15,
      laptop: 15,
      desktop: 15
    }),
    fontWeight: 'bold',
    marginBottom: 6,
  },

  activityMessage: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 12,
      tablet: 13,
      laptop: 13,
      desktop: 13
    }),
    marginBottom: 6,
    lineHeight: getResponsiveValue({
      mobile: 16,
      tablet: 17,
      laptop: 17,
      desktop: 17
    }),
  },

  activityUsername: {
    color: '#ffffff',
    fontWeight: 'bold',
  },

  activityTime: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 10,
      tablet: 11,
      laptop: 11,
      desktop: 11
    }),
  },

  noActivityText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
    textAlign: 'center',
    padding: 20,
  },

  headerProfile: {
    height: getResponsiveValue({
      mobile: 40,
      tablet: 40,
      laptop: 40,
      desktop: 50
    }),
    width: getResponsiveValue({
      mobile: 40,
      tablet: 40,
      laptop: 40,
      desktop: 50
    }),
    borderRadius: 25,
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: colors.backgroundSquares,
  },
  headerProfileImage: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  menuContainer: {
    width: 300,
    height: 350,
    backgroundColor: 'rgba(0,0,0,0.8)',
    borderRadius: 15,
    marginRight: 20,
    backdropFilter: Platform.OS === 'web' ? 'blur(100px)' : undefined,
    overflow: 'hidden',
    position: 'absolute',
    top: 12.5,
    right: 18,
    zIndex: 1000,
    transformOrigin: 'top right',
    ...(Platform.OS === 'web' && {
      transform: 'translate3d(0,0,0)',
      backfaceVisibility: 'hidden',
      perspective: 1000,
      borderTopRightRadius: 25,
    })
  },
  menuHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 20,
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.backgroundSquares,
    position: 'relative',
  },
  menuUsername: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 16,
      laptop: 20,
      desktop: 24
    }),
    textAlign: 'right',
  },
  menuProfileImage: {
    width: getResponsiveValue({
      mobile: 40,
      tablet: 40,
      laptop: 40,
      desktop: 50
    }),
    height: getResponsiveValue({
      mobile: 40,
      tablet: 40,
      laptop: 40,
      desktop: 50
    }),
    borderRadius: 25,
  },
  menuItems: {
    padding: getResponsiveValue({
      mobile: 10,
      tablet: 16,
      laptop: 18,
      desktop: 20
    }),
  },
  menuItem: {
    paddingVertical: getResponsiveValue({
      mobile: 5,
      tablet: 10,
      laptop: 10,
      desktop: 14
    }),
  },
  menuItemText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: getResponsiveValue({
      mobile: 12,
      tablet: 14,
      laptop: 14,
      desktop: 16
    }),
    textAlign: 'right',
  },
  menuItemActive: {
    color: '#0bb5df',
  },
  // Auth Styles
  authContainer: {
    width: '100%',
    marginTop: 20,
    maxWidth: 800,
    alignItems: 'center',
    padding: getResponsiveValue({
      mobile: 20,
      tablet: 25,
      laptop: 40,
      desktop: 40
    }),
    backgroundColor: '#4e7de0',
    borderRadius: 35,
    backdropFilter: 'blur(20px)',
    boxShadow: '0px 4px 4px rgba(255, 255, 255, 0.25)',
  },
  welcomeSection: {
    alignItems: 'center',
    marginBottom: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 30,
      desktop: 30
    }),
  },
  welcomeText: {
    fontFamily: 'DazHandwriting',
    fontWeight: '500',
    fontSize: getResponsiveValue({
      mobile: 24,
      tablet: 24,
      laptop: 32,
      desktop: 32
    }),
    color: "white",
    textAlign: 'center',
    marginBottom: 10,
    lineHeight: "180%",
  },
  appName: {
    fontFamily: 'DazHandwriting',
    fontWeight: '800',
    fontSize: getResponsiveValue({
      mobile: 24,
      tablet: 30,
      laptop: 48,
      desktop: 48
    }),
    paddingTop: 10,
  },
  authLogo: {
    width: Platform.OS === 'web' ? 120 : 100,
    height: Platform.OS === 'web' ? 120 : 100,
    // remove deprecated style-based resizeMode; set via prop where used
  },
  formSection: {
    width: '100%',
    gap: 15,
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    gap: 15,
    width: '100%',
    cursor: 'text',
  },
  authInput: {
    borderBottomWidth: 2,
    borderBottomColor: '#e9e9e7',
    borderStyle: 'solid', // this is needed for web
    width: '100%',
    color: 'white',
    fontFamily: 'Computer Says No',
    fontWeight: '400',
    paddingLeft: 8,
    fontSize: Platform.OS === 'web' ? 28 : 22,
    ...Platform.select({
      web: {
        outlineStyle: 'none',
      },
    }),
  },
  
  authInputLabel: {
    color: '#e9e9e7',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    whiteSpace: 'nowrap',
    paddingTop: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 4,
      desktop: 4
    }),
  },
  authActions: {
    width: '100%',
    alignItems: 'center',
    marginTop: 20,
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingHorizontal: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 15,
      desktop: 15
    }),
    gap: 10,
  },
  authButton: {
    backgroundColor: '#97ff11',
    padding: Platform.OS === 'web' ? 15 : 12,
    borderRadius: 8,
    width: '100%',
    alignItems: 'center',
    cursor: 'pointer',
  },
  authToggle: {
    marginTop: 20,
  },
  authToggleText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: Platform.OS === 'web' ? 16 : 14,
    textAlign: 'center',
  },
  authToggleLink: {
    color: '#0bb5df',
    textDecorationLine: 'underline',
  },
  // Sign Out Button Styles
  signOutButton: {
    backgroundColor: '#000000',
    padding: Platform.OS === 'web' ? 15 : 12,
    borderRadius: 20,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    width: '100%',
    alignItems: 'center',
    cursor: 'pointer',
    marginTop: 'auto',
    marginBottom: 20,
    marginHorizontal: 20,
    ...(Platform.OS === 'web' && {
      boxShadow: '0 2px 4px rgba(255, 255, 255, 0.1)',
    }),
  },
  signOutText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 16,
      laptop: 16,
      desktop: 18
    }),
    textAlign: 'center',
  },
  // Login Button Styles
  loginButton: {
    backgroundColor: '#0bb5df',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 25,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: 100,
    ...(Platform.OS === 'web' && {
      '&:hover': {
        backgroundColor: '#0a9bc0',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      },
    }),
  },
  loginButtonText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '600',
    fontSize: 16,
    textAlign: 'center',
  },
  // Sign Up Button Styles
  signupButton: {
    backgroundColor: 'transparent',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 25,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: 100,
    borderWidth: 1,
    borderColor: '#0bb5df',
    marginLeft: 10,
    ...(Platform.OS === 'web' && {
      '&:hover': {
        backgroundColor: 'rgba(11, 181, 223, 0.1)',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      },
    }),
  },
  signupButtonText: {
    color: '#0bb5df',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '600',
    fontSize: 16,
    textAlign: 'center',
  },
  authButtonsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  // Profile Grid Layout
  profileGrid: {
    width: '100%',
    maxWidth: 1200,
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    gap: 20,
    alignItems: 'flex-start',
  },
  profileColumn: {
    flex: 1,
    width: Platform.OS === 'web' ? '48%' : '100%',
    alignItems: 'stretch',
  },
  cardTitle: {
    fontFamily: 'DazHandwriting',
    fontSize: Platform.OS === 'web' ? 24 : 20,
    color: 'white',
    textAlign: 'center',
    marginBottom: 20,
    textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
  },
  placeholderText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: Platform.OS === 'web' ? 16 : 14,
    color: '#ffffff80',
    textAlign: 'center',
    marginTop: 20,
  },
  // Venue Screen Styles
  venueContainer: {
    flex: 1,
    borderRadius: 20,
    padding: Platform.OS === 'web' ? 43 : 20,
    width: '100%',
    maxWidth: 1095,
    alignSelf: 'center',
    marginTop: 20,
  },
  searchSection: {
    width: '100%',
    padding: 10,
    marginBottom: 20,
  },
  mainContent: {
    borderRadius: 20,
    width: '100%',
    padding: 20,
  },
  headerSection: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    gap: 10,
    marginBottom: 15,
  },
  venueInfo: {
    flex: 1,
    minWidth: 240,
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 10,
  },
  venueName: {
    fontFamily: 'VastagoGrotesk',
    fontSize: Platform.OS === 'web' ? 48 : 40,
    color: 'white',
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 2px 4px rgba(0, 0, 0, 0.5)' : undefined,
  },
  buttonGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    padding: 4,
  },
  overallGradeCard: {
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 10,
    alignItems: 'center',
    minWidth: 240,
  },
  gradeTitle: {
    fontFamily: 'DazHandwriting',
    fontSize: 24,
    color: 'white',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  reportCount: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
    color: 'white',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  gradeLetter: {
    fontFamily: 'VastagoGrotesk',
    fontSize: Platform.OS === 'web' ? 48 : 40,
    color: 'white',
    marginTop: 10,
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  contentSection: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    gap: 10,
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 20,
  },
  gradesSection: {
    flex: 1,
    minWidth: 240,
    gap: 10,
  },
  gradeCardGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  categoryRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  mediaSection: {
    width: Platform.OS === 'web' ? 503 : '100%',
    gap: 10,
  },
  venueImage: {
    width: '100%',
    height: 350,
    borderRadius: 10,
    ...(Platform.OS === 'web' ? { boxShadow: '0 4px 12px rgba(0,0,0,0.5)' } : {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.5,
      shadowRadius: 4,
    }),
  },
  actionButtonGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  // Grade Card Styles
  gradeCard: {
    flex: 1,
    minWidth: 160,
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 10,
    alignItems: 'center',
    ...(Platform.OS === 'web' ? { boxShadow: '0 2px 6px rgba(0,0,0,0.25)' } : {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.25,
      shadowRadius: 4,
    }),
  },
  gradeCardTitle: {
    fontFamily: 'DazHandwriting',
    fontSize: 12,
    color: 'white',
    textAlign: 'center',
  },
  gradeCardGrade: {
    fontFamily: 'VastagoGrotesk',
    fontSize: Platform.OS === 'web' ? 64 : 40,
    color: 'white',
    marginTop: 10,
  },
  // Category Button Styles
  categoryButton: {
    flex: 1,
    minWidth: 160,
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  buttonText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 16,
      laptop: 18,
      desktop: 20
    }),
    color: '#4e7de0',
    textAlign: 'center',
  },
  authNavText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 18,
      laptop: 22,
      desktop: 24
    }),
    color: "white",
    textAlign: 'center',
    marginBottom: 10,
    lineHeight: "180%",
  },
  categoryButtonText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 12,
    color: 'white',
    textAlign: 'center',
  },
  primaryButton: {
    backgroundColor: '#2ecc71',
  },
  // Venue List Styles
  venueListContainer: {
    flex: 1,
    paddingHorizontal: Platform.OS === 'web' ? 53 : 20,
    paddingTop: 20,
    width: '100%',
  },
  searchWrapper: {
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0)',
    height: 'auto',
    width: '100%',
    paddingTop: 40,
    alignItems: 'center',
    marginBottom: 40,
  },
  venueGrid: {
    flex: 1,
    width: '100%',
  },
  resultsContainer: {
    borderRadius: 15,
    backgroundColor: colors.backgroundSquares,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    minHeight: 700,
    width: '100%',
    padding: 15,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 30,
    justifyContent: 'center'
  },
  venueList: {
    display: 'grid',
    gridTemplateColumns: Platform.OS === 'web' ? 'repeat(3, 1fr)' : '1fr',
    gap: 30,
    width: '100%',
    padding: 20,
    ...(Platform.OS !== 'web' && {
      flexDirection: 'column',
      alignItems: 'center',
    }),
  },
  // Venue Card Styles
  venueCard: {
    borderRadius: 20,
    backgroundColor: colors.backgroundSquares,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    width: getResponsiveValue({
      mobile: '100%',
      tablet: '45%',
      laptop: 350,
      desktop: 400
    }),
    minHeight: getResponsiveValue({
      mobile: 150,
      tablet: 175,
      laptop: 200,
      desktop: 200
    }),
    maxHeight: getResponsiveValue({
      mobile: 250,
      tablet: 300,
      laptop: 350,
      desktop: 350
    }),
    alignItems: 'center',
    justifyContent: 'center',
    padding: getResponsiveValue({
      mobile: 15,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  venueCardName: {
    fontFamily: 'DazHandwriting',
    fontSize: 20,
    color: 'white',
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  venueCardAddress: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
    color: 'white',
    textAlign: 'center',
    marginTop: 10,
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  // Submit Report Styles
  submitReportContainer: {
    flex: 1,
    paddingHorizontal: Platform.OS === 'web' ? 50 : 20,
    paddingTop: 20,
  },
  submitReportTitle: {
    fontFamily: 'DazHandwriting',
    fontSize: 48,
    color: 'white',
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
    ...(Platform.OS !== 'web' && {
      fontSize: 40,
    }),
  },
  venueReportGrid: {
    display: Platform.OS === 'web' ? 'flex' : undefined,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 31,
    marginTop: 25,
    paddingBottom: 50,
  },
  venueReportCard: {
    borderRadius: 15,
    backgroundColor: colors.backgroundSquares,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    minWidth: 240,
    width: 298,
    margin: Platform.OS === 'web' ? 0 : 10,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  venueReportCardContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 200,
    paddingHorizontal: 10,
    ...(Platform.OS !== 'web' && {
      paddingVertical: 100,
    }),
  },
  venueReportCardTitle: {
    fontFamily: 'DazHandwriting',
    fontSize: 34,
    color: 'white',
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.5)' : undefined,
  },
  // Venue Submission Styles
  submissionContainer: {
    flex: 1,
    paddingHorizontal: Platform.OS === 'web' ? 54 : 20,
    paddingVertical: 20,
  },
  venueHeaderContainer: {
    width: '100%',
    borderRadius: 10,
    backgroundColor: colors.backgroundSquares,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    minHeight: 100,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 15,
  },
  venueHeaderTitle: {
    fontFamily: 'DazHandwriting',
    fontSize: Platform.OS === 'web' ? 48 : 40,
    color: 'white',
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  formContainer: {
    backgroundColor: colors.backgroundSquares,
    marginTop: 10,
    minHeight: 534,
    width: '100%',
    flexDirection: 'row',
    gap: 10,
    padding: 10,
  },
  formSection: {
    borderRadius: 10,
    minWidth: 240,
    width: '100%',
    flex: 1,
    padding: 20,
    zIndex: 3,
    alignItems: 'center',
  },
  fieldWrapper: {
    width: '100%',
    maxWidth: 366,
    marginTop: 15,
  },
  fieldLabel: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 18,
    color: 'white',
    marginBottom: 10,
  },
  fieldInput: {
    width: '100%',
    borderRadius: 100,
    backgroundColor: 'rgba(217,217,217,0.5)',
    minHeight: 40,
    paddingVertical: 0,
    paddingHorizontal: 20,
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
    }),
  },
  navigationContainer: {
    flexDirection: 'row',
    marginTop: 10,
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: Platform.OS === 'web' ? 100 : 20,
    flexWrap: 'wrap',
  },
  navigationButton: {
    flex: 1,
    minWidth: 240,
    maxWidth: 293,
    borderRadius: 10,
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  navigationButtonText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 20,
    color: 'white',
    textAlign: 'center',
  },
  backButton: {
    backgroundColor: '#FF000A',
  },
  nextButton: {
    backgroundColor: '#2ECC71',
  },
  scrollContainer: {
    flexGrow: 1,
    minHeight: '100%',
    justifyContent: 'center',
  },
  continueWithoutLoginButton: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: colors.textSecondary,
    marginTop: 20,
  },
  continueWithoutLoginText: {
    color: colors.textSecondary,
  },
  actionButton: {
    ...Platform.select({
      web: {
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        ':hover': {
          ...animations.buttonHover,
        },
      },
    }),
  },
  animatedCard: {
    ...(Platform.OS === 'web' && {
      transition: 'all 0.3s ease-in-out',
      ':hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
      },
    }),
  },
  text: {
    fontFamily: 'VastagoGrotesk',
  },
  // Hamburger menu styles
  hamburgerButton: {
    width: 40,
    height: 40,
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 8,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  hamburgerLine: {
    width: '100%',
    height: 2,
    backgroundColor: '#ffffff',
    borderRadius: 1,
  },
  
  // Mobile menu styles
  mobileMenuOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#000000',
    zIndex: 1001,
  },
  mobileMenuContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: getResponsiveValue({
      mobile: '100%',
      tablet: '50%',
      laptop: '30%',
      desktop: '30%'
    }),
    backgroundColor: 'rgba(20, 20, 20, 0.95)',
    zIndex: 1002,
    paddingTop: 20,
    paddingBottom: 40,
    paddingHorizontal: 20,
    backdropFilter: 'blur(10px)',
    ...(Platform.OS === 'web' && {
      boxShadow: '-4px 0 10px rgba(0, 0, 0, 0.5)',
    }),
  },
  mobileMenuHeader: {
    marginBottom: 30,
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 20,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  closeButtonText: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: '600',
  },
  mobileProfileSection: {
    alignItems: 'center',
    marginTop: 30,
    position: 'relative',
  },
  mobileProfileImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginBottom: 15,
  },
  mobileUsername: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '600',
    fontSize: 20,
    marginBottom: 5,
  },
  mobileVerifiedBadge: {
    position: 'absolute',
    top: 5,
    right: '30%',
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: '#ffffff',
  },
  mobileMenuItems: {
    marginTop: 20,
  },
  mobileMenuItem: {
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255, 255, 255, 0.1)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
      },
    }),
  },
  mobileMenuItemText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: 18,
  },
  mobileSignOutButton: {
    marginTop: 30,
    padding: 15,
    backgroundColor: '#000000',
    borderRadius: 8,
    alignItems: 'center',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 4px rgba(255, 255, 255, 0.1)',
      ':hover': {
        backgroundColor: '#1a1a1a',
      },
    }),
  },
  mobileSignOutText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '600',
    fontSize: 16,
  },
  searchInput: {
    backgroundColor: 'transparent',
    color: '#000000',
    width: '100%',
    fontSize: 16,
    height: 50,
    paddingHorizontal: 20,
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
    }),
  },
  placeholderStyle: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
  },
  // Plans Page Styles
  plansContent: {
    alignItems: 'center',
    color: '#000000',
    justifyContent: 'flex-start',
    paddingTop: 80,
  },
  plansHeader: {
    alignItems: 'center',
    marginBottom: 40,
  },
  plansTitle: {
    fontFamily: 'DazHandwriting',
    fontSize: 48,
    marginBottom: 10,
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 2px 4px rgba(0,0,0,0.3)' : undefined,
  },
  plansSubtitle: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 18,
    opacity: 0.9,
    textAlign: 'center',
  },
  planCard: {
    backgroundColor: '#4e7de0',
    borderRadius: 20,
    padding: 30,
    width: '100%',
    maxWidth: 500,
    alignItems: 'center',
    backdropFilter: Platform.OS === 'web' ? 'blur(10px)' : undefined,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
  },
  planHeader: {
    alignItems: 'center',
    marginBottom: 30,
  },
  planName: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 24,
    color: '#ffffff',
    marginBottom: 15,
    fontWeight: '600',
  },
  priceContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  priceCurrency: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 24,
    color: '#fbe28b',
    marginTop: 10,
  },
  priceAmount: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 64,
    color: '#fbe28b',
    fontWeight: '700',
  },
  pricePeriod: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 20,
    color: '#fbe28b',
    marginTop: 15,
    opacity: 0.8,
  },
  featuresContainer: {
    width: '100%',
    marginBottom: 30,
    paddingHorizontal: 30,
  },
  featuresTitle: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 18,
    color: '#ffffff',
    marginBottom: 20,
    opacity: 0.9,
  },
  featureItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
  },
  featureIcon: {
    color: '#2ecc71',
    fontSize: 18,
    marginRight: 10,
    fontWeight: 'bold',
  },
  featureText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
    color: '#ffffff',
    opacity: 0.9,
  },
  subscribeButton: {
    backgroundColor: '#FFFFFF',
    paddingVertical: 15,
    paddingHorizontal: 40,
    borderRadius: 30,
    marginBottom: 20,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
      },
    }),
  },
  subscribeButtonText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 18,
    color: '#4e7de0',
    whiteSpace: 'nowrap',
    fontWeight: '600',
  },
  guaranteeText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
    color: '#ffffff',
    opacity: 0.7,
  },
});